import { render, staticRenderFns } from "./TagPage.vue?vue&type=template&id=e7767326&scoped=true&"
import script from "./TagPage.vue?vue&type=script&lang=js&"
export * from "./TagPage.vue?vue&type=script&lang=js&"
import style0 from "./TagPage.vue?vue&type=style&index=0&id=e7767326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7767326",
  null
  
)

export default component.exports